import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SERVICE_BASE_URLS } from '../../services/apiConfig';
import './PaymentSuccess.css';

const PaymentSuccess = () => {
  const [verificationStatus, setVerificationStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        // Parse URL parameters
        const queryParams = new URLSearchParams(location.search);
        const reference = queryParams.get('reference');
        
        if (!reference) {
          setVerificationStatus('failed');
          setMessage('Payment reference not found in URL');
          toast.error('Payment reference not found');
          return;
        }
  
        // Create verification URL with extracted reference
        const verificationUrl = `http://203.161.55.192:8087/bservice/api/v1/auth/verify-transaction?reference=${reference}`;
        
        // Make verification request - removed token authorization
        const response = await axios.post(verificationUrl, {});
  
        // Handle successful verification
        // setVerificationStatus('success');
        // setMessage(response.data.message || 'Payment verified successfully!');
        toast.success(response.data.message,{
          position: 'top-center',
          autoClose: 5000,
        });
        
        // Redirect after 3 seconds
        setTimeout(() => {
          navigate('/d/vendor-status');
        }, 5000);
  
      } catch (error) {
        console.error('Payment verification error:', error);
        setVerificationStatus('failed');
        
        let errorMessage = 'Failed to verify payment';
        if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        }
        
        setMessage(errorMessage);
        toast.error(errorMessage);
      }
    };
  
    verifyPayment();
  }, [location, navigate]);

  return (
    <div className="payment-verification-container">
      <ToastContainer />
      <div className="payment-verification-card">
        <div className="payment-logo-container">
          <img src="/assets/genie.png" alt="Genie Logo" className="payment-logo" />
        </div>

        <div className="payment-header">
          <h1>Payment Verification</h1>
          {verificationStatus === 'verifying' && (
            <>
              <div className="spinner"></div>
              <p>Verifying your payment, please wait...</p>
            </>
          )}
          
          {verificationStatus === 'success' && (
            <>
              <div className="success-icon">✓</div>
              <p>{message}</p>
              <p className="redirect-message">Redirecting back to your Dashboard in a few seconds...</p>
            </>
          )}
          
          {verificationStatus === 'failed' && (
            <>
              <div className="error-icon">✗</div>
              <p>{message}</p>
              <button 
                className="retry-button"
                onClick={() => navigate('/d/pricing-plans')}
              >
                Return to Subscriptions
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;